module.exports = __webpack_public_path__ + "static/img/venkatesh.deaeb62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/venkatesh.jpg
// module id = 512
// module chunks = 11